import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  Button,
  useColorModeValue,
  Text,
  Divider,
  ModalCloseButton,
  Flex,
} from '@chakra-ui/react';

interface RemoveLanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  redesigned?: boolean;
}

const RemoveLanguageModal = ({
  isOpen,
  onClose,
  onConfirm,
  redesigned = false,
}: RemoveLanguageModalProps) => {
  const modeBoxBg = useColorModeValue('white', 'secondaryDark');
  const modeLabelBg = useColorModeValue('white', 'primaryDark03');

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  if (redesigned) {
    return (
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        closeOnOverlayClick={false}
        isCentered
        size="lg"
      >
        <ModalOverlay />
        <ModalContent bg="white" p={6} borderRadius="15px">
          <ModalCloseButton _hover={{ bg: 'transparent', color: 'grey' }} />
          <ModalBody>
            <Text textStyle="heading4" textAlign="center" py={3}>
              Remove language?
            </Text>
            <Divider my={4} borderColor="lightGrey" />
            <Text fontSize="15px" color="black" textAlign="center">
              All translations for this language will be permanently deleted. This
              can&apos;t be undone.{' '}
            </Text>
          </ModalBody>
          <Flex mt={6} mb={3} justifyContent="center" gap={4}>
            <Button
              variant="secondaryFlat"
              size="sm"
              minW="160px"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              size="sm"
              minW="160px"
              onClick={handleConfirm}
            >
              Remove language
            </Button>
          </Flex>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      closeOnOverlayClick={false}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent
        bg={modeBoxBg}
        p="10px"
        borderRadius="15px"
        justifyContent="center"
        alignItems="center"
      >
        <ModalCloseButton />
        <ModalBody bg={modeLabelBg}>
          <Text textStyle="heading4" textAlign="center">
            Remove language?
          </Text>
          <Divider my="20px" />
          <Text fontSize="16px" my="10px" mx="20px">
            Are you sure you want to remove this language? Any translations
            entered in these fields will be permanently lost.
          </Text>
        </ModalBody>
        <ModalFooter display="flex" justifyContent="flex-end" gap={3}>
          <Button variant="secondary" size="sm" onClick={onClose}>
            <Text>Cancel</Text>
          </Button>
          <Button onClick={handleConfirm} size="sm">
            Remove
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RemoveLanguageModal;
